import { TrnLikeMypageAddRequest } from '@/types/request';
import { postLikeMypageAdd, postLikeMypageBulkRemove } from '../trnLikeMypageEndpoint';
import { AddFavoriteResponse } from '@/types/favorite';
import { AxiosError } from 'axios';

export const setLikeMypageAddService = async (params: TrnLikeMypageAddRequest) => {
  let response = {} as AddFavoriteResponse;
  try {
    response = (await postLikeMypageAdd(params)).data;
  } catch (error) {
    const err = error as AxiosError;
    const status = err.response?.status;
    response = response || {};
    response.exceptionResponse = response.exceptionResponse || {};
    response.exceptionResponse.statusCode = status ?? 500;
    response.exceptionResponse.messageError = err.message || 'Unknown error';
  }

  return response;
};

export const setLikeMypageBulkRemoveService = async (params: { orderIds: number[] }) => {
  return (await postLikeMypageBulkRemove(params)).data;
};
